import styled from 'styled-components';

import Button from '@/components/Base/Button';
import {
  colorGrey400,
  colorLink400,
  colorPrimary400,
  colorSecondary50,
  colorSecondary400,
  colorWhite,
  fontFamilySecondary,
  HoverState,
  mediaQueryLaptopMin,
} from '@/styleUtils';
import { SectionStyles } from '@/styleUtils/section';

export const Wrapper = styled.div`
  grid-area: sidebarContent;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
export const StickyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: ${({ $isSticky }) => ($isSticky ? 'sticky' : '')};
  top: 8px;
`;
export const Title = styled.p`
  font: 700 20px/28px ${fontFamilySecondary};
`;
export const StyledButton = styled(Button)`
  font: 700 16px/24px ${fontFamilySecondary};
  color: ${colorPrimary400};
  border: 1px solid rgba(80, 118, 192, 0.56);
  ${HoverState};
  background: ${colorWhite};
`;
export const SidebarNavigation = styled.div`
  ${SectionStyles};
  padding: 24px 0 8px 0;
  border-radius: 8px;
`;
export const NavigationTitle = styled.p`
  font: 700 22px/28px ${fontFamilySecondary};
  margin-bottom: 16px;
  margin-left: 16px;
  @media ${mediaQueryLaptopMin} {
    margin-left: 24px;
  }
`;
export const NavigationItem = styled.div`
  display: inline-flex;
  gap: ${({ $index }) => ($index < 9 ? '16px' : '8px')};
  align-items: center;
  padding: 12px 16px;
  width: 100%;
  cursor: pointer;
  p {
    font: 400 14px/20px ${fontFamilySecondary};
    color: ${colorLink400};
  }
  &.active {
    background-color: ${colorSecondary50};
    p {
      color: ${colorSecondary400};
    }
  }
  &:hover {
    background-color: ${colorSecondary50};
    p {
      color: ${colorSecondary400};
    }
  }
  @media ${mediaQueryLaptopMin} {
    padding: 12px 24px;
  }
`;
export const Number = styled.div`
  font: 400 14px/24px ${fontFamilySecondary};
  color: ${colorGrey400};
`;

export default Wrapper;
